document.querySelectorAll('[data-href]').forEach((divLink: HTMLElement) => {
    divLink.onclick = (): void => {
        window.location.href = divLink.dataset.href;
    };
});
